import React from "react";
import { Colours } from "../../../utils/colours";

export const Check: React.FC<DogsTrust.IconProps> = ({
	height = "30px",
	width = "30px",
	fill = Colours.SUNSHINE_YELLOW,
	...props
}) => {
	return (
		<svg
			{...props}
			aria-hidden="true"
			focusable="false"
			viewBox="0 0 10 8"
			height={height}
			width={width}
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M1 4.455 3.383 7 9 1"
				stroke={fill}
				strokeWidth={2}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default Check;
